import { Controller } from "@hotwired/stimulus"

// Opens a Help::HowtoStoryComponent dialog by id (the story sits elsewhere on the page, so it listens for howto:open).
export default class extends Controller {
  static values = { target: String }

  open(event) {
    event.preventDefault()
    document.getElementById(this.targetValue)?.dispatchEvent(new CustomEvent("howto:open"))
  }
}
